import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio as RadioComponent,
  FormLabel,
  FormHelperText,
  useTheme
} from '@mui/material';
import { ReactNode } from 'react';
import { Controller, Control } from 'react-hook-form';

interface Props {
  name: string;
  control: Control<any>;
  label: string;
  options: { label: string | ReactNode; value: string | number | boolean; disabled?: boolean }[];
}

export default function Radio({ name, control, label, options }: Props) {
  const theme = useTheme();

  return (
    <FormControl>
      <FormLabel>{label}</FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => {
          return (
            <>
              <RadioGroup
                row
                {...field}
                onChange={(event) => {
                  const selectedValue = options.find(
                    (option) => option.value?.toString() === event.target.value
                  )?.value;
                  field.onChange(selectedValue);
                }}
              >
                {options.map((option, index) => (
                  <FormControlLabel
                    key={index}
                    value={option.value}
                    defaultValue={field.value}
                    control={<RadioComponent />}
                    label={option.label}
                    disabled={option.disabled}
                    sx={{ margin: '8px 0' }}
                  />
                ))}
              </RadioGroup>
              <FormHelperText sx={{ color: theme.palette.error.main }}>{error ? error.message : null}</FormHelperText>
            </>
          );
        }}
      />
    </FormControl>
  );
}
